import { useEffect, useState } from 'react';

import { displayableMediaUrl } from '../widget-lib/media-url';

type Props = {
  photoUrl?: string | null;
  /** Подпись для инициала при отсутствии фото */
  label: string;
  sizeClass?: string;
  roundedClass?: string;
  /** Для `<img sizes>` при будущем srcset; без srcset влияет мало, но не мешает. */
  imgSizes?: string;
};

/**
 * Аватар по URL или заглушка с инициалом; не грузит некорректные и битые URL.
 * Согласовано с frontend/admin MediaAvatar (список тренеров).
 */
export function MediaAvatar({
  photoUrl,
  label,
  sizeClass = 'h-8 w-8',
  roundedClass = 'rounded-full',
  imgSizes = '48px'
}: Props) {
  const [broken, setBroken] = useState(false);
  useEffect(() => setBroken(false), [photoUrl]);

  const src = displayableMediaUrl(photoUrl);
  const showImg = src != null && !broken;
  const initial = (label || '?')[0]?.toUpperCase() ?? '?';

  /** Оболочка: overflow-hidden + rounded обрезает img по кругу (только rounded на img даёт квадрат в части браузеров/layout). */
  const shell = `shrink-0 overflow-hidden ${roundedClass} ${sizeClass}`;

  if (showImg) {
    return (
      <span className={`inline-flex ${shell}`}>
        <img
          src={src}
          alt=""
          sizes={imgSizes}
          decoding="async"
          className="h-full w-full object-cover"
          onError={() => setBroken(true)}
        />
      </span>
    );
  }

  return (
    <div
      className={`flex ${shell} items-center justify-center bg-[var(--bg-soft)] text-xs font-semibold text-[var(--text-muted)]`}
      aria-hidden
    >
      {initial}
    </div>
  );
}
